import type { FC } from "react";

import {
  TABS_DEFAULTS,
  type TTabsProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { TabsContent } from "@/ui/components/navigation/Tabs/TabsContent";
import { TabsList } from "@/ui/components/navigation/Tabs/TabsList";
import { TabsRoot } from "@/ui/components/navigation/Tabs/TabsRoot";
import { TabsTrigger } from "@/ui/components/navigation/Tabs/TabsTrigger";
import { cn } from "@/ui/lib/utils";

export const Tabs: FC<TTabsProps> = (
  {
    className,
    contentClassName,
    defaultValue,
    listClassName,
    tabs,
    triggerClassName,
    value,
    variant = TABS_DEFAULTS.variant,
    ...props
  },
) => (
  <TabsRoot
    data-component="Tabs"
    className={cn("w-full", className)}
    defaultValue={defaultValue ?? value ?? tabs[0]?.value}
    value={value}
    {...props}
  >
    <TabsList
      variant={variant}
      className={listClassName}
    >
      { tabs.map((tab) => (
        <TabsTrigger
          key={tab.value}
          value={tab.value}
          disabled={tab.disabled}
          variant={variant}
          className={triggerClassName}
        >
          { tab.label }
        </TabsTrigger>
      )) }
    </TabsList>
    { tabs.map((tab) => (
      <TabsContent
        key={tab.value}
        value={tab.value}
        className={contentClassName}
      >
        { tab.content }
      </TabsContent>
    )) }
  </TabsRoot>
);

Tabs.displayName = "Tabs";
